// extracted by css-extract-rspack-plugin
export default {"root":"root-abVdhe","active":"active-nDYn_2","radioIcon":"radioIcon-IQYRFg","check":"check-xpiU9z","iconWrapper":"iconWrapper-Ba6JoD"};